<template>
  <div class="containner">
    <div class="news_title">
      交通建证件查询
      <span class="iconfont">&#xe70b;</span>自治区交通证件查询
    </div>

    <div class="queryBox">
      <div class="queryBoxTitle">
        <div class="queryBoxText">自治区交通证件查询</div>
        <div class="triangle"></div>
      </div>
      <div class="queryBoxInp">
        <p>
          <input type="text" class="form-control" placeholder="请输入姓名" aria-describedby="basic-addon1" v-model="con_enforce_name">
        </p>
        <p>
          <input type="text" class="form-control" placeholder="请输入证件号" aria-describedby="basic-addon1" v-model="con_enforce_number">
        </p>
      </div>
      <div class="queryBoxBnt">
        <el-button type="warning" round  @click="clear">重置</el-button>
        <el-button type="danger" round @click="getMsg">查询</el-button>
      </div>
    </div>
    <div class="queryResult" v-show="state">
      <div>查询结果</div>
      <table>
        <thead>
          <td>执法类别</td>
          <td>所属单位</td>
          <td>姓名</td>
          <td>性别</td>
          <td>执法证号</td>
        </thead>
        <tbody>
          <tr v-for="(item,index) in data" :key="index">
            <td>{{item.enforce_type}}</td>
            <td>{{item.enforce_department}}</td>
            <td>{{item.enforce_name}}</td>
            <td>{{item.enforce_sex}}</td>
            <td>{{item.enforce_number}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import {ipconfig} from '@/assets/js/ipconfig.js'
import Axios from "axios";
export default {
  name: "credentialsQuery1",
  data() {
    return {
      con_enforce_number: "",
      con_enforce_name: "",
      data:null,
      state:false
    };
  },
  methods: {
    getMsg() {
      let url = `http://${ipconfig}/app/isweb/law/getRegionLaw?con_enforce_name=${
        this.con_enforce_name
      }&innerMS&con_enforce_number=${this.con_enforce_number}`;
      Axios.get(url).then(res => {
        if(res.data.isSuccess){
          this.state = true;
          this.data = res.data.data.regionLaw
          console.log( this.data )
        }
        //console.log(res.data);
      });
    },
    clear(){
      this.state = false
      this.data = null;
      this.con_law_number='';
      this.con_law_name=''
    }
  }
};
</script>
<style scoped>
.queryBox {
  width: 50%;
  height: 40%;
  margin: 30px auto;
  /* border: 1px solid red; */
}
.queryBoxTitle {
  height: 20%;
  width: 50%;
  /* border: 1px solid red; */
  position: relative;
}
.queryBoxText {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35px;
  border-radius: 5px;
  background: #f74f35;
  color: white;
  font-weight: bold;
}
.triangle {
  position: absolute;
  right: 50%;
  border-style: solid;
  border-width: 10px;
  border-color: #f74f35 transparent transparent transparent;
  width: 0px;
  height: 0px;
}
.queryBoxInp > p{
  margin-bottom: 20px;
}
.queryBoxInp{
  margin-bottom: 20px;
}
.queryBoxBnt{
  text-align: center;
}
.queryResult{
  width: 80%;
  height: 30%;
  margin: 30px auto;
  /* border: 1px solid red; */
}
.queryResult table{
  width: 100%;
}
.queryResult table td{
  text-align: center;
  /* border: 1px solid red; */
}
.queryResult table tbody{
  overflow: hidden;
}
.queryResult table tbody td{
  font-size: 12px;
}
.containner {
  height: 100%;
}
.news_title {
  height: 6%;
  /* border: 1px solid red; */
  /* line-height: 5%; */
  padding-left: 5px;
  background: #ccc;
  display: flex;
  align-items: center;
}
.iconfont {
  font-size: 10px;
  margin: 0 5px;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/pages/jtzjquery/credentialsQuery1.vue


// WEBPACK FOOTER //
// src/pages/jtzjquery/credentialsQuery1.vue